// AI-CONTEXT: See docs/features/compare-two-periods.md
//
// Human label for a period range (ISO 'YYYY-MM-DD' bounds) shown above each
// panel in a ComparisonFrame. Mirrors formatReportPeriod's wording, but takes
// an ISO {start, end} instead of a report's Timestamp Start/End. No bounds =
// 'Alles' (all-time).

/** @param {string} iso @returns {string} 'YYYY-MM-DD' → 'DD-MM-YYYY' */
const isoToUI = (iso) => {
    const [y, m, d] = iso.split('-')
    return `${d}-${m}-${y}`
}

/**
 * @param {{start: string|null, end: string|null}|null|undefined} range
 * @returns {string} e.g. '01-01-2025 – 31-12-2025', 'Vanaf 01-06-2025', 'Tot 31-12-2025', 'Alles'
 */
const formatPeriodLabel = (range) => {
    const start = range?.start ? isoToUI(range.start) : null
    const end = range?.end ? isoToUI(range.end) : null
    if (start && end) return `${start} – ${end}`
    if (start) return `Vanaf ${start}`
    if (end) return `Tot ${end}`
    return 'Alles'
}

export default formatPeriodLabel
